import React, { FC, useState, useEffect, useMemo, useCallback } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProfile, bProfile, ProfileRole } from '@brg/auth';
import { FInter, useIsMobile, useToasts, FlexBox, Dropdown, DropdownListItem, Colors, useBreakpoint, HintTooltip } from "@brg/ui";
import { API, Competition, CompetitionAPI, Endpoints, Lang, Project } from "@brg/api";
import {
  MainBlock,
  HeaderBlock,
  TitleText,
  HeaderRightBlock,
  HeaderBlockNotAuto,
  SmthTitle,
  TitleTextNotAuto,
  SmthBanner,
  SmthIconsWrapperNotAuto,
  CompetitionTagsContainer,
  ButtonsWrapper,
  MobileStatusPseudoTagsWrap,
} from './style';
import { scrollFunc } from './utils';
import { PSLongread, getLongreadId } from 'shared/pages/project/sections/ps-longread';
import { useGetManyByListPaginated } from 'shared/hooks/api/LMS/useGetManyByListPaginated';
import ActionsButtons, { CompetitionDisableBtnStatus } from './ActionsButtons';
import { COMPETITION_TYPE, isRatingCompetitionType, STATUSES } from '_competition/const';
import { SlideNavigation } from 'shared/components/slideNavigation';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionJuryPage } from '_competition/pages/JuryPage/CompetitionJuryPage';
import { CompetitionProjectsPage } from '_competition/pages/ProjectsPage/CompetitionInfoPage';
import { ShortListPage } from '_competition/pages/ShortListPage/ShortListPage';
import { EncodedStateFilter, useEncodedStateFilter } from 'shared/components/Filters';
import { isCompetitionHasFinalyst } from 'shared/helpers/competitionStatus';
import { HseContextActions } from "../../../reducers/hseCurrentContext";
import { useDispatch, useSelector } from "react-redux";
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { LimitedLink, StatusPseudoTag } from 'shared/pages/project/project';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { BTag } from 'core/components';
import { bTag, LayoutConst } from 'core';
import { DeadLineWarningWrapper, IconCompetitionSpecial } from 'shared/assets/styles';
import ShareIcon from 'shared/assets/32/ShareIcon';
import { BottomOuterMobile } from 'shared/components/template/project-display-layout';
import { TagsMobBtn } from 'shared/components/TagsMobBtn/TagsMobBtn';
import TagsMobile from 'shared/pages/project/components/TagsMobile';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import styled, { ThemeProvider, useTheme, css } from 'styled-components';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { CompetitionView } from '_competition/pages/AllCompetitionsPage/CompetitionView';
import { CopyIcon } from './assets/CopyIcon';
import { COMPETITION_STATUSES, getCompetitionStatus } from "../../../../_competition/helpers/getCompetitionStatus";
import { useShowRatingCompetitionTag } from '_competition/helpers/useShowRatingCompetitionTag';
import WarningIcon from "../../../icons/WarningIcon";
import { createThemeByColor } from "../../../helpers/coloring";
import { CustomBgWrapper } from "../../../components/CustomBgWrapper/CustomBgWrapper";
import { MobileFilterRow, MobileFilterSort } from 'shared/pages/explore/styles';
import { SortIcon } from 'shared/icons';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { AppTester } from 'supporting';
import { MagicBoxRow } from "../../../components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import ResizedImageEnhanced from "../../../components/ResizedImageEnhanced";
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { CompetitionEditFrameForbidden } from 'shared/components/error-frames';
import { PreShortListPage } from '_competition/pages/ShortListPage/PreShortListPage';
import ReactTooltip from "react-tooltip";
import { getTooltipStyles, tooptipStylesWhite } from "../../../constants/tooptipStyles";
import { BTagsGridNew } from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { useModal } from 'core';
import { AccessModalTypes } from 'shared/modals/AccessModal/AccessModal';
import { useAuth } from 'core/auth';
import MetaTags from 'shared/components/MetaTags';
import { useAutoOpenModal } from 'shared/hooks/useAutoOpenModal';
import { CurrentCompetitionActions, CurrentCompetitionSelector } from 'shared/reducers/CurrentCompetitionSlice';
import { NominationsView } from './sections/NominationsView';
import { FormProvider, useForm } from 'react-hook-form';
import { ProjectMetaBack } from 'shared/components/ProjectMetaBack/ProjectMetaBack';
import { CompetitionErrorNotAllowed } from 'shared/components/error-frames/competition-edit-frames';
import { useGetCompetitionNominations } from 'shared/hooks/api/useGetCompetitionNominations';
import { TAB_IDS } from './const';

const BRIEF_ERROR_FORBIDDEN_MSG = 'This user is not approved to view this competition'

export enum TABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  shortlist = 'shortlist',
  results = 'results'
}
export enum SPECIALTABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  select = 'shortlist',
  shortlist = 'finalists',
}
export const CUSTOMTABS: { [key: string]: string } = {
  '1': 'about',
  '2': 'jury',
  '3': 'projects',
  '4': 'shortlist',
  '5': 'results',
};

const DropdownText = styled(FInter.SmallTextBoldMagic) <{ isActive?: boolean, isDark?: boolean, isAcademy?: boolean }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  
  ${({ isActive, theme, isDark, isAcademy }) => isActive ? css`
    color: ${isAcademy ? Colors.geoWhite100 : isDark ? theme.icon.hoverSpecialActive : theme.icon.active};
  ` : null}
`;
const TabletSortWrapper = styled(FlexBox)`
  gap: 8px;
  
`

const getUrl = (encodedState: string, ctx?: boolean) => {
  if (ctx) {
    const id = window.location.pathname.split('/')[2];
    return `/competition/${id}/context/${encodedState}`;
  }
  return `${window.location.pathname}`
}

interface CompetitionPageProps {
  id?: string;
}

// TODO потом удалить, Нурс временно попросил!!!!
export const COMPETITIONS_WITH_OPEN_PROJECTS = ['0439ccbea0944f25a6ea380c0c465bd6', '3ed8dd343f454c0a9052a92e57cac8f1', 'a049d4b8f2094fbb85b29ec11fa2f30d']

export const CompetitionPage: FC<CompetitionPageProps> = (props) => {

  return (
    <EncodedStateFilter getUrl={getUrl}>
      <GetCompetitionItem {...props} />
    </EncodedStateFilter>
  )
};

const GetCompetitionItem: FC<CompetitionPageProps> = ({ id: externalId }) => {
  const { id = externalId } = useParams<{ id: string }>();
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const is744BP = useBreakpoint(LayoutConst.screen.s);
  const is743BP = useBreakpoint(LayoutConst.screen.s - 1);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const theme1 = useTheme();
  const profile = useProfile();
  const { info } = useToasts();
  const breakpoint = useBreakpoint(576);
  const auth = useAuth();
  const modal = useModal();
  const {
    sorting,
    setSorting,
  } = useEncodedStateFilter();
  const [selectedTab, setSelectedTab] = useState('about');
  const [scroll, setScroll] = useState(false);
  const [target, setTarget] = useState('');
  const [briefForbiddenError, setBriefForbiddenError] = useState<any>(null)
  const [accessError, setAccessError] = useState<boolean>(false);
  // const [competition, setCompetition] = useState<Competition<'Local'>>();
  const [showMobileTags, setShowMobileTags] = useState(false);
  const [time, setTime] = useState(Date.now());
  const [isLoading, setIsLoading] = useState(false);
  const isAcademy = AppTester.isAcademy();
  const isGreenAward = AppTester.isGreenAward();
  const isDamuseum = AppTester.isDaMuseum();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCompetitionRoute = !!useRouteMatch(LinkTo.competition);
  const { competition } = useSelector(CurrentCompetitionSelector)
  const showRatingTag = useShowRatingCompetitionTag(competition);

  const isCompetitionCompleted = useMemo(() => (competition && isCompetitionHasFinalyst(competition)), [competition])

  const initialTab = useMemo(() => (isCompetitionCompleted ? TABS.shortlist : TABS.about), [isCompetitionCompleted])

  const [{ tab: queryTab = initialTab, unrated }, setQueryParams] = useQueryState();
  const competitionStatus = getCompetitionStatus(competition);
  const isByCategory = !!(competition as any)?.isByCategory;
  const getCategoryColorTheme = (tag: any) => {
    if (!isByCategory || !tag?.isTagCategory) return undefined;
    const whiteOnly = !!tag?.hasEduTags
    const bg = whiteOnly ? '#102D69': 'rgba(16, 45, 105, 0.50)';

    return {
      fill: { default: bg, hover: bg, disabled: bg },
      text: { default: '#FFF', hover: '#FFF', disabled: '#FFF' },
    };
  };
  const bgColor = useMemo(() => (isAcademy ? '#2A3034' : (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.competitionType === COMPETITION_TYPE.Automatic) ? theme1.competition.bg : competition?.competitionColorTheme?.backgroundColor) || '#FEFEFE', [competition, theme1, isAcademy])

  // @ts-ignore
  const longreadId = useMemo(() => competition ? getLongreadId(competition, i18n.language) : null, [competition, i18n.language]);
  
  const idsLongread = useMemo(() => longreadId ? [longreadId] : [], [longreadId]);

  useAutoOpenModal();

  const { paging: longreadPaging } = useGetManyByListPaginated({
    idsLongread,
    limit: 0,
    offset: 0,
    page: 0,
    disabled: !longreadId,
  });

  const hasLongreadData = useMemo(() => {
    return longreadPaging && longreadPaging.count > 0;
  }, [longreadPaging]);

  const { theme, isDarkText } = createThemeByColor(bgColor, theme1, { isCompetition: true });
  const isDarkTheme = useMemo(() => !isDarkText, [isDarkText])

  const [{ allowedInfo, allowedStatus, isMaxAttemptsLimitLoading }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);
  const { nominations, isLoading: nominationsLoading } = useGetCompetitionNominations(competition?.competitionId ?? '', false )
  
  const hasEndedNominationsWithWinners = useMemo(() => {
    if (nominationsLoading) return false;
    return nominations?.some((n: any) =>
      [STATUSES.Completed, STATUSES.Archived]?.includes(n?.status) &&
      n?.nominations?.[0]?.winnerPositions?.length > 0
    ) ?? false;
  }, [nominations, nominationsLoading]);

  // @ts-ignore
  const showPreShortList = competition?.nominations?.[0]?.showPreShortList;

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: TABS,
      initialTab,
    }));
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [TABS, dispatch])


  useEffect(() => {
    if (!profile && queryTab !== initialTab) {
      setQueryParams({ tab: TABS.about }, { replace: true });
    }
  }, [profile])

  const [activeTabKey, setActiveTabKey] = useState(queryTab);

  const isModer = useMemo(() => {
    if (profile && competition) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      return (bProfile.isModer(profile) || hasPolicyCompetitionModer ||
        competition?.moderatorID?.includes(profile?.accountId) ||
        competition?.administratorID?.includes(profile?.accountId)
      )
    }
  }, [profile, competition])

  const isBriefModer = useMemo(() => ((profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList)) || undefined), [profile])
  const isModerOrBriefModer = !!isModer || !!(isBriefModer && competition?.isBriefCompetition)

  const isCanSubmitOnBrief = useMemo(
    () => competition && !!competition?.isBriefCompetition &&
      allowedInfo && allowedInfo?.includes(CompetitionDisableBtnStatus.max_briefs), [competition, allowedInfo])

  //@ts-ignore
  const isAllowParticipants = useMemo(() => (competition?.allowEmptyParticipantRequests), [competition])

  const isParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.participantAccountIds?.includes(profile?.accountId)), [competition, profile])

  const isPendingParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.pendingParticipantsIds?.includes(profile?.accountId)), [competition, profile])

  const isPreRegistrationCompetition = useMemo(() => {
    const rawType = competition?.competitionType;
    const hasCompetitionType = Number.isInteger(rawType);
    if (hasCompetitionType) {
      return rawType === COMPETITION_TYPE.PreRegistration;
    }
    return !!competition?.isPreRegistration;
  }, [competition]);

  const isCanViewPreRegistration = useMemo(
    //@ts-ignore
    () => (isPreRegistrationCompetition && !competition?.participantAccountIds?.includes(profile?.accountId) && competition?.status === STATUSES.Open),
    [profile, competition, isPreRegistrationCompetition]
  )

  const isCanSubmitProjects = useMemo(
    () => (
      /*isParticipant || */
      isPendingParticipant ||
      (isCanSubmitOnBrief && !isModer) ||
      (!!allowedInfo?.length && !isModer
      ) ||
      competition?.status !== STATUSES.Open
    )
    , [
      isParticipant,
      competition,
      isCanSubmitOnBrief,
      isModer,
      isPendingParticipant,
      allowedInfo
    ]);

  const isJury = useMemo(() => !!profile && !!competition?.juryID?.includes(profile?.designerId), [competition, profile]);
  const isVsContext = useMemo(() => (competition && competition?.contexts?.includes('hsevisualresearch')), [competition]);
  const isCompetitionModer = useMemo(() => profile && competition?.moderatorID?.includes(profile?.designerId), [competition, profile]);

    const tabVisibilityRules = useMemo(() => {
      const isAdmin = isModer || isCompetitionModer || isJury;
      const isPracticeCompetition = competition?.competitionType === COMPETITION_TYPE.Practices;
      const isOpenCompetition = COMPETITIONS_WITH_OPEN_PROJECTS.includes(competition?.competitionId || '')
      
      const getEnabledStatus = (tabId: string) => {
        return competition?.infoTabs?.find((tab) => tab.tabId === tabId)?.enable;
      }

      return {
        about: true,
        jury: isAdmin || getEnabledStatus(TAB_IDS.jury),
        projects: isAdmin || isPracticeCompetition || isOpenCompetition || getEnabledStatus(TAB_IDS.projects),
        shortlist: isAdmin || (getEnabledStatus(TAB_IDS.shortlist) && isCompetitionCompleted),
        results: !!(competition?.hasManyCompetitions && hasEndedNominationsWithWinners),
      }
    }, [isModer, isCompetitionModer, isJury, competition, hasEndedNominationsWithWinners])


    const formMethods = useForm({
      defaultValues: {}
    });
    // const { handleSubmit, reset, watch, setValue, control } = formMethods;

  const canViewStatements = useMemo(() => {
    if (!profile || !profile.rolesList || !Array.isArray(profile.rolesList)) {
      return false;
    }
    
    const hasLmsAdmin = (new ProfileRole(HsePolicies.lms_admin)).containsIn(profile.rolesList);
    const hasLmsChief = (new ProfileRole(HsePolicies.lms_scores_report_chief)).containsIn(profile.rolesList);
    const hasLmsEditor = (new ProfileRole(HsePolicies.lms_scores_report_editor)).containsIn(profile.rolesList);
    
    return isJury || hasLmsAdmin || hasLmsChief || hasLmsEditor;
  }, [profile, isJury]);

  // const isDarkTheme = useMemo(() => (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.isNewType), [competition])
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])
  const is1440 = useMemo(() => (isMac13 || smHeight), [isMac13, smHeight]);

  const canViewCompetitionPoint = useMemo(() => (
    (isJury && isVsContext) || isModer || isCompetitionModer), [isJury, isCompetitionModer, isVsContext, isModer]);

  const onMobileSortingChange = useCallback(() => {
    setSorting(Number(sorting) === 1 ? 2 : 1);
    setTime(Date.now())
  }, [sorting])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    setTime(Date.now());
  }, [setSorting])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        // hideRightBar={true}
        onSortingChange={onSortingChange}
        onToggleUnrated={() => { }}
        sortingMethods={canViewCompetitionPoint ? [1, 2, 13, ...(isJury ? [] : [])] : [1, 2]}
        isDarkTheme={isDarkTheme}
      />
    ),
    [onSortingChange, sorting, isMobile, sorting, canViewCompetitionPoint, isDarkTheme],
  );

  const MobileSearchBar = useMemo(
    () => (
      <MobileFilterRow
        // fixed={isMobile}
        importantWidth
        style={{
          marginTop: 0,
          justifyContent: 'flex-end',
          paddingTop: '0px',
          width: '100% !important'
        }}
      >
        <MobileFilterSort onClick={() => onMobileSortingChange()}>
          <SortIcon />
          {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : Number(sorting) === 2 ? 'popular' : 'score'}`)}
        </MobileFilterSort>
      </MobileFilterRow>
    ), [isMobile, sorting])


  const UnratedBar = useMemo(() => {
    if (!(isJury && (activeTabKey === TABS.projects))) {
      return null;
    }
    return (
      <FlexBox style={{ justifyContent: 'flex-end', width: isMobile ? '100%' : 'initial' }} offsetTopMobile={0} offsetTop={is743BP ? 24 : 0} offsetRight={isMobile ? 0 : 16} offsetRightMobile={0}>
        <MagicBoxRow
          label={t('filter.unrated')}
          // checked={extraFilter?.globalType?.includes('employee') || extraFilter?.globalType?.length === 0}
          checked={Boolean(unrated)}
          style={{ margin: isMobile ? '0' : '0 0 0 0', color: isHSEDesign ? theme.text.label : theme.inputs.disabledColor }}
          onClick={() => {

            setQueryParams({
              unrated: unrated === 'true' ? '' : 'true',
              page: 1
            })
          }}
        />
      </FlexBox>
    )
  }, [unrated, setQueryParams, isMobile, activeTabKey, isJury])

  const competitionTabs = useMemo(() => {
    const tabs: Record<string, string> = {};
    const specialTabs: Record<string, string> = {};

    const getCustomTabName = (key: string, val: string): string => {
      const tabId = TAB_IDS[key as keyof typeof TAB_IDS];
      const infoTab = tabId && competition?.infoTabs?.find((t) => t.tabId === tabId);
      const stored = infoTab ? Lang(infoTab.name, i18n.language) : '';
      return stored || t(`competition.tabs.${val}`);
    };

    if (showPreShortList) {
      Object.entries(SPECIALTABS).forEach(([key, val]) => {
        specialTabs[key] = getCustomTabName(key, val);
      })
      return specialTabs
    }

    Object.entries(TABS).filter(([key, val]) => {
      return tabVisibilityRules[key as keyof typeof tabVisibilityRules]
    }).map(([key, val]) => {
      tabs[key] = getCustomTabName(key, val);
    })

    return tabs;
  }, [
    tabVisibilityRules,
    t,
    competition,
    i18n.language,
    showPreShortList,
  ]);

  //@ts-ignore
  const isPaidCompetition = useMemo(() => competition?.lmsModuleProjectId && competition?.isPaidApplication, [competition])
  //@ts-ignore
  const isExam = useMemo(() => !!competition?.lmsModuleProjectId, [competition])
  const isJoinCompetitionButtonTypeVisible = useMemo(() => {
    if (isExam) {
      return false;
    }

    //@ts-ignore
    const competitionType = competition?.competitionType;

    if (competitionType === COMPETITION_TYPE.WithNominations
      || competitionType === COMPETITION_TYPE.Automatic
      || isRatingCompetitionType(competitionType)) {
      return false;
    }

    if (competitionType === COMPETITION_TYPE.WithQuestionnaire
      || competitionType === COMPETITION_TYPE.WithoutQuestionnaire
      || competitionType === COMPETITION_TYPE.PreRegistration
      || competitionType === COMPETITION_TYPE.Practices
      || !!competition?.isPaidCompetition
      || competitionType === COMPETITION_TYPE.Special) {
      return true;
    }

    return isPreRegistrationCompetition;
  }, [competition, isExam, isPreRegistrationCompetition]);

  const actionButtonVisible = useMemo(() => {
    if (isPaidCompetition) {
      return false
    }
    if (!!isModer || !!(isBriefModer && competition?.isBriefCompetition)) {
      return competitionStatus < COMPETITION_STATUSES.full_finish
    }
    if (isExam) {
      return false
    }

    if (!isJoinCompetitionButtonTypeVisible) {
      return false;
    }
    if(competition?.status === STATUSES.Announcement) {
      return false;
    }
    return (competitionStatus === COMPETITION_STATUSES.default
      || competitionStatus === COMPETITION_STATUSES.deadline_soon)
  }, [competitionStatus, isPaidCompetition, isExam, isModer, isBriefModer, competition, isJoinCompetitionButtonTypeVisible])

  const statementsButtonVisible = useMemo(() => {
    return !!canViewStatements && !!competition?.lmsModuleProjectId;
  }, [canViewStatements, competition?.lmsModuleProjectId])
  const canRenderActionButtons = actionButtonVisible && (isModerOrBriefModer || !statementsButtonVisible)

  useEffect(() => {
    setActiveTabKey(queryTab);
  }, [queryTab]);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      CompetitionAPI.Get({ idCompetition: id, initWinner: true })
        .then((v) => v.json())
        .then((v) => {
          if (v.status && v.status === 403) {
              setAccessError(true);
              return;
          }
          //@ts-ignore
          if (v?.['ErrorStatusCode'] === 500 && v?.['ErrorMessage'] === BRIEF_ERROR_FORBIDDEN_MSG) {
            //@ts-ignore
            setBriefForbiddenError(true)
            return;
          }
          return API.toLang<Competition<'Local'>>(v, i18n.language)
        })
        .then((competition) => {
          // setCompetition(competition)

          dispatch(CurrentCompetitionActions.setCurrentCompetition(competition))
        })
        .finally(() => {
          if (isGreenAward) {
            setTimeout(() => setIsLoading(false), 1000)
          } else {
            setIsLoading(false)
          }
        })

    }
  }, [id, i18n.language]);

  useEffect(() => {
    const updateActiveOnScroll = (value: string) => {
      setTarget("");
      setScroll(true);
      setSelectedTab(value);
    };

    const handler = () => {
      const { scrollHeight, clientHeight } = document.documentElement;
      const { scrollY } = window;

      if (scrollY + 1 >= scrollHeight - clientHeight) {
        updateActiveOnScroll('contacts');
      } else if (scrollY <= 800) {
        setTarget("");
        setScroll(false);
        setSelectedTab('about');
      } else if (scrollY > 800 && scrollY <= 1200 && !is744BP) {
        updateActiveOnScroll('about');
      } else if (scrollY > 1200 && scrollY <= 1500 && !is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 800 && scrollY <= 1200 && is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 1900 && scrollY <= 2600 && !is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 1200 && scrollY <= 2400 && is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 2600 && scrollY <= 4200) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 2400 && scrollY <= 6800 && is744BP) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 4200 && scrollY <= 5900 && !is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 6800 && scrollY <= 7300 && is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 5900 && scrollY <= 6200 && !is744BP) {
        updateActiveOnScroll('contacts');
      } else if (scrollY > 7300 && is744BP) {
        updateActiveOnScroll('contacts');
      }
    };

    window.addEventListener('scroll', handler);
    scrollFunc(target, is744BP);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [target, selectedTab, scroll, is744BP]);

  useEffect(() => {
    return () => {
      dispatch(CurrentCompetitionActions.setCurrentCompetition(undefined))
    }
  } , [])

  const titleImages = useMemo(() => {
    if (competition?.isBilingual) {
      return i18n.language === 'en' ? competition?.titleImages_en : competition?.titleImages
    }
    return competition?.titleImages;
  }, [competition, i18n.language])

  //хардкод для для конкурса
  const showArrowTabIcon = useMemo(() => {
    return competition && competition?.competitionId === '43bd8964119e473c9944c1ef43aee6f2'
  }, [competition])

  const isBriefPreregistration = useMemo(
    () => (!!competition?.isBriefCompetition && isPreRegistrationCompetition && isCanViewPreRegistration),
    [competition, isCanViewPreRegistration, isPreRegistrationCompetition]
  )

  const buttonText = useMemo(
    () => {
      if (!!competition?.isBriefCompetition && isPreRegistrationCompetition) {
        return t(`hse_showcases_title.competitions.msg.${isCanViewPreRegistration ? 'go_requests' : 'send_project'}`)
      }

      return competition?.enrollButtonText ?? ''
    }, [t, competition, isCanViewPreRegistration, isPreRegistrationCompetition])



  const handleCopy = () => {
    const linkText = window.location.href;
    navigator.clipboard.writeText(linkText)
      .then(() => {
        info(t('notifications.copy_msg-success'))
      })
      .catch(err => {
        info(t('notifications.copy_msg-error'))
      });
  }

  const handlePaidCompetitionClick = useCallback(() => {
    if (!profile) {
      auth.login();
    } else {
      API.request()
        .endpoint(Endpoints.geoGateway)
        .url('/api/LMS/RequestToJoinCourse')
        .addQuery('projectId', competition?.lmsModuleProjectId ?? '')
        .post()
        .send()
        .then(() => {
          modal.show("access", {
            type: AccessModalTypes.LMS,
            projectId: competition?.lmsModuleProjectId
          });
        })

    }
  }, [profile, auth, modal]);

  // Обработчики событий
  const onTabChange = (tab: string) => {
    if (isDamuseum && !isCompetitionRoute) {
      history.push(CreateLinkTo.competition(competition?.competitionId ?? ''))
    }
    setQueryParams({ tab });
  }

  const backgroundColor = isGreenAward
    ? 'linear-gradient(to bottom, rgba(49, 83, 43, 1), rgba(118, 158, 57, 1))'
    : (
      isAcademy
        ? '#2A3034'
        : (
          (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE'
            && competition?.competitionType === COMPETITION_TYPE.Automatic)
            ? theme.competition.bg
            : competition?.competitionColorTheme?.backgroundColor
        )
        || undefined
    )

  if (accessError) {
    return (
      <CompetitionErrorNotAllowed id={ id ?? '' }/>
    )
  }

  if (briefForbiddenError) {
    return (
      <CompetitionEditFrameForbidden id={''} />
    )
  }

  return (
    <>
      <MetaTags
        title={competition?.title ?? ''}
        images={competition?.titleImages}
      />
      <ThemeProvider theme={theme as any}>
            <FormProvider {...formMethods}>
        <CustomBgWrapper isCompetition backgroundColor={
          backgroundColor
        }
        >
          <MainBlock isMobile={is744BP} isAcademy={isAcademy}>
            <ProjectMetaBack />
            {competition?.isNewType ? (
              <HeaderBlock isMobile={is744BP}>
                <CompetitionView competition={competition} />
                <HeaderRightBlock isMobile={is744BP}>
                  <FlexBox width="100%" direction='column' directionMobile="column">
                    {/* {competition?.title && <TitleText isMobile={is743BP}>{competition?.title}</TitleText>} */}
                    {!is743BP && (<BTagsGridNew customShadowColor={backgroundColor} shadow>
                      {
                        competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                          <StatusPseudoTag onClick={(e: any) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }} mr={16} mb={12}>
                            {
                              t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                'competition.statuses.Competition_ended'
                                :
                                'competition.statuses.Competition_apply_ended')
                            }
                          </StatusPseudoTag>
                          :
                          undefined
                      }
                      {showRatingTag && (
                        <StatusPseudoTag backgroundColor="#29894E" onClick={(e: any) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }} mr={16} mb={12}>
                          {t('competition.statuses.rating_competition')}
                        </StatusPseudoTag>
                      )}
                      {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                        // @ts-ignore
                        const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                        const colorTheme = getCategoryColorTheme(v);
                        return (
                          // <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>

                          <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag colorTheme={colorTheme}>
                            {bTag.title(v)}
                            <ReactTooltip {...getTooltipStyles(theme as any)} />

                          </BTag>
                          // </LimitedLink>
                        )
                      })}
                    </BTagsGridNew>)}
                  </FlexBox>
                  <FlexBox width="100%" direction='column' justify={'end'} directionMobile={'column'}>

                    {is743BP && (<FlexBox>
                      <BottomOuterMobile>
                        {(competitionStatus === COMPETITION_STATUSES.full_finish
                          || competitionStatus === COMPETITION_STATUSES.apply_finish
                          || showRatingTag) && (
                          <MobileStatusPseudoTagsWrap>
                            {
                              competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                                <StatusPseudoTag
                                  onClick={(e: any) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                  }}
                                  mr={8}>
                                  {
                                    t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                      'competition.statuses.Competition_ended'
                                      :
                                      'competition.statuses.Competition_apply_ended')
                                  }
                                </StatusPseudoTag>
                                :
                                null
                            }
                            {showRatingTag && (
                              <StatusPseudoTag
                                backgroundColor="#29894E"
                                onClick={(e: any) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                }}
                                mr={8}>
                                {t('competition.statuses.rating_competition')}
                              </StatusPseudoTag>
                            )}
                          </MobileStatusPseudoTagsWrap>
                        )}
                        <FlexBox directionMobile='row'>
                          <FlexBox offsetRight={'12px'}>
                            <IconCompetitionSpecial onClick={handleCopy}>
                              <ShareIcon />
                            </IconCompetitionSpecial>
                          </FlexBox>
                        </FlexBox>
                        {!![...competition?.requredTags, ...competition?.regularTags]?.length && (
                          <div className="BottomOuterMobileActions">
                            <FlexBox directionMobile="row" gxMobile={12}>
                              <TagsMobBtn isCompetition customText={t('tags_mobile_btn_text').toLowerCase()} onClick={setShowMobileTags} flag={showMobileTags} />
                            </FlexBox>
                          </div>
                        )}
                      </BottomOuterMobile>

                    </FlexBox>)}
                    {is743BP && showMobileTags && (<FlexBox offsetTopMobile={'10px'}>
                      <TagsMobile show={showMobileTags}>
                        {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                          // @ts-ignore
                          const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                          const colorTheme = getCategoryColorTheme(v);
                          return (
                            <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>
                              {/*@ts-ignore*/}
                              <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag colorTheme={colorTheme}>
                                {bTag.title(v)}
                              </BTag>
                            </LimitedLink>
                          )
                        })}
                      </TagsMobile>
                    </FlexBox>)}
                    {!isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && !competition?.hasManyCompetitions && <DeadLineWarningWrapper>
                      <div><WarningIcon /></div>
                      <span>{t('competition.ten_days-remain_msg')}</span>
                    </DeadLineWarningWrapper>}
                    <FlexBox direction='row' directionMobile={'column'} width={'100%'} widthMobile={'100%'} justify='space-between' justifyMobile='space-between' align='flex-end' alignMobile='flex-start'>

                      {!is744BP && (
                        <FlexBox offsetBottom={0} offsetBottomMobile={16} direction='column' directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center' style={{ placeItems: 'center' }}>
                          <IconCompetitionSpecial onClick={handleCopy} style={{ marginBottom: 0, marginTop: (!isMobile && (competitionStatus === COMPETITION_STATUSES.default || competitionStatus === COMPETITION_STATUSES.deadline_soon)) ? 24 : 0 }}>
                            <ShareIcon />
                          </IconCompetitionSpecial>
                          {isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && competition?.hasManyCompetitions && (
                            <DeadLineWarningWrapper>
                              <div><WarningIcon /></div>
                              <span>{t('competition.ten_days-remain_msg')}</span>
                            </DeadLineWarningWrapper>
                          )}
                        </FlexBox>
                      )}
                      {is743BP && competitionStatus === COMPETITION_STATUSES.deadline_soon && <DeadLineWarningWrapper>
                        <div><WarningIcon /></div>
                        <span>{t('competition.ten_days-remain_msg')}</span>
                      </DeadLineWarningWrapper>}
                      {(actionButtonVisible || statementsButtonVisible) && <FlexBox justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0} direction='column' align='flex-end' alignMobile='flex-start'>
                        {statementsButtonVisible && (
                          <FlexBox offsetBottom={8}  width={is744BP ? '100%' : 'auto'}>
                            <SendProjectButton
                              color={theme.competition.buttonText}
                              className='moder-button statements-button'
                              c={theme.competition.buttonBg}
                              hoverC={theme.competition.secondaryText}
                              onClick={() => {
                                history.push(`/estimate/${competition.lmsModuleProjectId}`);
                              }}
                              r="3"
                              fullWidth={false}
                            >
                              {t('lms.statements.title')}
                            </SendProjectButton>
                          </FlexBox>
                        )}
                        {canRenderActionButtons && <ActionsButtons
                          isModer={isModerOrBriefModer}
                          isPreRegistration={isCanViewPreRegistration}
                          isBriefPreregistration={isBriefPreregistration}
                          disabled={isCanSubmitProjects && !isGreenAward}
                          isAllowParticipants={isAllowParticipants ?? false}
                          needAuth={!profile}
                          text={buttonText}
                          allowedInfo={allowedInfo}
                          allowedStatus={allowedStatus}
                          isMaxAttemptsLimitLoading={isMaxAttemptsLimitLoading}
                        />}
                      </FlexBox>}
                      {isPaidCompetition && (
                        <HintTooltip
                          text={t('hints.paid_competition_hint')}
                          positionY='top'
                          onWhiteBg
                        >
                          <SendProjectButton
                            color={theme.competition.buttonText}
                            className='moder-button'
                            c={theme.competition.buttonBg}
                            hoverC={theme.competition.secondaryText}
                            onClick={handlePaidCompetitionClick}
                            r="3"
                          >
                            {t('competition.request_member')}
                          </SendProjectButton>
                        </HintTooltip>
                      )}

                    </FlexBox>
                  </FlexBox>
                </HeaderRightBlock>
              </HeaderBlock>
            ) : (
              <HeaderBlockNotAuto isMobile={is744BP}>
                <FlexBox direction="column" directionMobile='column-reverse'>
                  <SmthTitle isMobile={is744BP}>
                    <TitleTextNotAuto isMobile={is744BP}>{competition?.title}</TitleTextNotAuto>
                  </SmthTitle>
                  <SmthBanner isMobile={is744BP}>
                    <ResizedImageEnhanced files={titleImages} />
                  </SmthBanner>
                </FlexBox>
                <FlexBox width="100%" height={'auto'} justify='space-between' justifyMobile='flex-end' direction='row' directionMobile='column-reverse'
                  style={{ maxWidth: '1152px', placeItems: 'end' }}>
                  <SmthIconsWrapperNotAuto>
                    <CopyIcon onClick={handleCopy} />
                  </SmthIconsWrapperNotAuto>
                  {canRenderActionButtons && competition && <ActionsButtons
                    isModer={isModerOrBriefModer}
                    disabled={isCanSubmitProjects}
                    isPreRegistration={isCanViewPreRegistration}
                    isAllowParticipants={isAllowParticipants ?? false}
                    isBriefPreregistration={isBriefPreregistration}
                    fullWidth={breakpoint}
                    needAuth={!profile}
                    text={buttonText}
                    allowedInfo={allowedInfo}
                    allowedStatus={allowedStatus}
                    isMaxAttemptsLimitLoading={isMaxAttemptsLimitLoading}
                  />}
                </FlexBox>
              </HeaderBlockNotAuto>
            )}
            {is743BP && UnratedBar}
            <FlexBox width={'100%'} offsetTopMobile={16} offsetBottomMobile={'16px'} offsetBottom={!is1440 ? 4 : 0} justifyMobile='end'>
              {is743BP ? (
                <>
                  <FlexBox directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center'>
                    {!!Object.keys(competitionTabs)?.length && (
                      <Dropdown
                        offsetY={-2}
                        hideArrow
                        dark={isDarkTheme}
                        orientation={'left'}
                        target={
                          <ArrowTopIconWithText
                            fill={isDarkTheme ? theme.competition.secondaryText : undefined}
                            isCompetition={true}
                            text={competitionTabs[activeTabKey]}
                            shrimpIcon
                          />
                        }
                      >
                        {Object.keys(competitionTabs)?.map((key) => {
                          return (
                            <div key={key} onClick={() => {
                              if (key === activeTabKey) return false;
                              onTabChange(key);
                            }}>
                              <DropdownListItem
                                justify='space-between'
                                isActive={key === activeTabKey}
                              >
                                <DropdownText isDark={!!competition?.isNewType} isAcademy={isAcademy} isActive={key === activeTabKey}>
                                  {competitionTabs[key]}
                                </DropdownText>
                                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey} />
                              </DropdownListItem>
                            </div>
                          )
                        }
                        )}
                      </Dropdown>
                    )}
                    {activeTabKey === TABS.projects && MobileSearchBar}

                  </FlexBox>
                </>
              ) : (
                <FlexBox width={'100%'} offsetTop={!competition?.isNewType ? 20 : 0}>
                  <SlideNavigation
                    items={competitionTabs}
                    activeIndexKey={activeTabKey}
                    onChange={onTabChange}
                    //хардкод стрелки для конкруса
                    arrowIconId={showArrowTabIcon ? 'projects' : ''}
                    padding={24}
                    capitalize={true}
                  />
                  <TabletSortWrapper>
                    {UnratedBar}
                    {activeTabKey === TABS.projects && (isMobile ? MobileSearchBar : searchBar)}
                  </TabletSortWrapper>

                </FlexBox>
              )}
            </FlexBox>
            {(
              activeTabKey === TABS.about ? (
                <FlexBox offsetTopMobile={4} width={'100%'}>
                  <PSLongread project={competition as unknown as Project<"Local">} courseButtons={[]} />
                </FlexBox>
              ) : activeTabKey === TABS.jury ? (
                <CompetitionJuryPage openLikeTab externalId={externalId} />
              ) : activeTabKey === TABS.projects ? (
                <CompetitionProjectsPage openLikeTab mobileSorting={sorting} onMobileSortingChange={setSorting} isDarkTheme={isDarkTheme} externalId={externalId} />
              ) : [TABS.shortlist, TABS.results]?.includes(activeTabKey) ? (
                <ShortListPage showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : activeTabKey === 'select' ? (
                <PreShortListPage activeTabKey={activeTabKey} showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : (
                <>
                  <PSLongread project={competition as unknown as Project<"Local">} courseButtons={[]} />
                </>
              )
            )}
            {activeTabKey === TABS.about && <NominationsView />}
            {!isLoading && canRenderActionButtons && hasLongreadData && !(['projects', 'shortlist'].includes(queryTab)) && <ButtonsWrapper isMobile={is744BP} justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0}>
              <ActionsButtons
                isModer={isModerOrBriefModer}
                isPreRegistration={isCanViewPreRegistration}
                isBriefPreregistration={isBriefPreregistration}
                disabled={isCanSubmitProjects}
                isAllowParticipants={isAllowParticipants ?? false}
                needAuth={!profile}
                text={buttonText}
                allowedInfo={allowedInfo}
                allowedStatus={allowedStatus}
                isMaxAttemptsLimitLoading={isMaxAttemptsLimitLoading}
              />
            </ButtonsWrapper>}
          </MainBlock>
        </CustomBgWrapper>
        </FormProvider>
      </ThemeProvider>
    </>
  );
};

export default GetCompetitionItem;
import React, { FC, useState, useEffect, useMemo, useCallback } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProfile, bProfile, ProfileRole } from '@brg/auth';
import { FInter, useIsMobile, useToasts, FlexBox, Dropdown, DropdownListItem, Colors, useBreakpoint, HintTooltip } from "@brg/ui";
import { API, Competition, CompetitionAPI, Endpoints, Lang, Project } from "@brg/api";
import {
  MainBlock,
  HeaderBlock,
  TitleText,
  HeaderRightBlock,
  HeaderBlockNotAuto,
  SmthTitle,
  TitleTextNotAuto,
  SmthBanner,
  SmthIconsWrapperNotAuto,
  CompetitionTagsContainer,
  ButtonsWrapper,
  MobileStatusPseudoTagsWrap,
} from './style';
import { scrollFunc } from './utils';
import { PSLongread, getLongreadId } from 'shared/pages/project/sections/ps-longread';
import { useGetManyByListPaginated } from 'shared/hooks/api/LMS/useGetManyByListPaginated';
import ActionsButtons, { CompetitionDisableBtnStatus } from './ActionsButtons';
import { COMPETITION_TYPE, isRatingCompetitionType, STATUSES } from '_competition/const';
import { SlideNavigation } from 'shared/components/slideNavigation';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionJuryPage } from '_competition/pages/JuryPage/CompetitionJuryPage';
import { CompetitionProjectsPage } from '_competition/pages/ProjectsPage/CompetitionInfoPage';
import { ShortListPage } from '_competition/pages/ShortListPage/ShortListPage';
import { EncodedStateFilter, useEncodedStateFilter } from 'shared/components/Filters';
import { isCompetitionHasFinalyst } from 'shared/helpers/competitionStatus';
import { HseContextActions } from "../../../reducers/hseCurrentContext";
import { useDispatch, useSelector } from "react-redux";
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { LimitedLink, StatusPseudoTag } from 'shared/pages/project/project';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { BTag } from 'core/components';
import { bTag, LayoutConst } from 'core';
import { DeadLineWarningWrapper, IconCompetitionSpecial } from 'shared/assets/styles';
import ShareIcon from 'shared/assets/32/ShareIcon';
import { BottomOuterMobile } from 'shared/components/template/project-display-layout';
import { TagsMobBtn } from 'shared/components/TagsMobBtn/TagsMobBtn';
import TagsMobile from 'shared/pages/project/components/TagsMobile';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import styled, { ThemeProvider, useTheme, css } from 'styled-components';
import { ApprovedIcon } from 'shared/icons/ApprovedIcon';
import { CompetitionView } from '_competition/pages/AllCompetitionsPage/CompetitionView';
import { CopyIcon } from './assets/CopyIcon';
import { COMPETITION_STATUSES, getCompetitionStatus } from "../../../../_competition/helpers/getCompetitionStatus";
import { useShowRatingCompetitionTag } from '_competition/helpers/useShowRatingCompetitionTag';
import WarningIcon from "../../../icons/WarningIcon";
import { createThemeByColor } from "../../../helpers/coloring";
import { CustomBgWrapper } from "../../../components/CustomBgWrapper/CustomBgWrapper";
import { MobileFilterRow, MobileFilterSort } from 'shared/pages/explore/styles';
import { SortIcon } from 'shared/icons';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { AppTester } from 'supporting';
import { MagicBoxRow } from "../../../components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import ResizedImageEnhanced from "../../../components/ResizedImageEnhanced";
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { CompetitionEditFrameForbidden } from 'shared/components/error-frames';
import { PreShortListPage } from '_competition/pages/ShortListPage/PreShortListPage';
import ReactTooltip from "react-tooltip";
import { getTooltipStyles, tooptipStylesWhite } from "../../../constants/tooptipStyles";
import { BTagsGridNew } from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { useModal } from 'core';
import { AccessModalTypes } from 'shared/modals/AccessModal/AccessModal';
import { useAuth } from 'core/auth';
import MetaTags from 'shared/components/MetaTags';
import { useAutoOpenModal } from 'shared/hooks/useAutoOpenModal';
import { CurrentCompetitionActions, CurrentCompetitionSelector } from 'shared/reducers/CurrentCompetitionSlice';
import { NominationsView } from './sections/NominationsView';
import { FormProvider, useForm } from 'react-hook-form';
import { ProjectMetaBack } from 'shared/components/ProjectMetaBack/ProjectMetaBack';
import { CompetitionErrorNotAllowed } from 'shared/components/error-frames/competition-edit-frames';
import { useGetCompetitionNominations } from 'shared/hooks/api/useGetCompetitionNominations';
import { TAB_IDS } from './const';

const BRIEF_ERROR_FORBIDDEN_MSG = 'This user is not approved to view this competition'

export enum TABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  shortlist = 'shortlist',
  results = 'results'
}
export enum SPECIALTABS {
  about = 'about',
  jury = 'jury',
  projects = 'projects',
  select = 'shortlist',
  shortlist = 'finalists',
}
export const CUSTOMTABS: { [key: string]: string } = {
  '1': 'about',
  '2': 'jury',
  '3': 'projects',
  '4': 'shortlist',
  '5': 'results',
};

const DropdownText = styled(FInter.SmallTextBoldMagic) <{ isActive?: boolean, isDark?: boolean, isAcademy?: boolean }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  
  ${({ isActive, theme, isDark, isAcademy }) => isActive ? css`
    color: ${isAcademy ? Colors.geoWhite100 : isDark ? theme.icon.hoverSpecialActive : theme.icon.active};
  ` : null}
`;
const TabletSortWrapper = styled(FlexBox)`
  gap: 8px;
  
`

const getUrl = (encodedState: string, ctx?: boolean) => {
  if (ctx) {
    const id = window.location.pathname.split('/')[2];
    return `/competition/${id}/context/${encodedState}`;
  }
  return `${window.location.pathname}`
}

interface CompetitionPageProps {
  id?: string;
}

// TODO потом удалить, Нурс временно попросил!!!!
export const COMPETITIONS_WITH_OPEN_PROJECTS = ['0439ccbea0944f25a6ea380c0c465bd6', '3ed8dd343f454c0a9052a92e57cac8f1', 'a049d4b8f2094fbb85b29ec11fa2f30d']

export const CompetitionPage: FC<CompetitionPageProps> = (props) => {

  return (
    <EncodedStateFilter getUrl={getUrl}>
      <GetCompetitionItem {...props} />
    </EncodedStateFilter>
  )
};

const GetCompetitionItem: FC<CompetitionPageProps> = ({ id: externalId }) => {
  const { id = externalId } = useParams<{ id: string }>();
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const is744BP = useBreakpoint(LayoutConst.screen.s);
  const is743BP = useBreakpoint(LayoutConst.screen.s - 1);
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
  const theme1 = useTheme();
  const profile = useProfile();
  const { info } = useToasts();
  const breakpoint = useBreakpoint(576);
  const auth = useAuth();
  const modal = useModal();
  const {
    sorting,
    setSorting,
  } = useEncodedStateFilter();
  const [selectedTab, setSelectedTab] = useState('about');
  const [scroll, setScroll] = useState(false);
  const [target, setTarget] = useState('');
  const [briefForbiddenError, setBriefForbiddenError] = useState<any>(null)
  const [accessError, setAccessError] = useState<boolean>(false);
  // const [competition, setCompetition] = useState<Competition<'Local'>>();
  const [showMobileTags, setShowMobileTags] = useState(false);
  const [time, setTime] = useState(Date.now());
  const [isLoading, setIsLoading] = useState(false);
  const isAcademy = AppTester.isAcademy();
  const isGreenAward = AppTester.isGreenAward();
  const isDamuseum = AppTester.isDaMuseum();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCompetitionRoute = !!useRouteMatch(LinkTo.competition);
  const { competition } = useSelector(CurrentCompetitionSelector)
  const showRatingTag = useShowRatingCompetitionTag(competition);

  const isCompetitionCompleted = useMemo(() => (competition && isCompetitionHasFinalyst(competition)), [competition])

  const initialTab = useMemo(() => (isCompetitionCompleted ? TABS.shortlist : TABS.about), [isCompetitionCompleted])

  const [{ tab: queryTab = initialTab, unrated }, setQueryParams] = useQueryState();
  const competitionStatus = getCompetitionStatus(competition);
  const isByCategory = !!(competition as any)?.isByCategory;
  const getCategoryColorTheme = (tag: any) => {
    if (!isByCategory || !tag?.isTagCategory) return undefined;
    const whiteOnly = !!tag?.hasEduTags
    const bg = whiteOnly ? '#102D69': 'rgba(16, 45, 105, 0.50)';

    return {
      fill: { default: bg, hover: bg, disabled: bg },
      text: { default: '#FFF', hover: '#FFF', disabled: '#FFF' },
    };
  };
  const bgColor = useMemo(() => (isAcademy ? '#2A3034' : (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.competitionType === COMPETITION_TYPE.Automatic) ? theme1.competition.bg : competition?.competitionColorTheme?.backgroundColor) || '#FEFEFE', [competition, theme1, isAcademy])

  // @ts-ignore
  const longreadId = useMemo(() => competition ? getLongreadId(competition, i18n.language) : null, [competition, i18n.language]);
  
  const idsLongread = useMemo(() => longreadId ? [longreadId] : [], [longreadId]);

  useAutoOpenModal();

  const { paging: longreadPaging } = useGetManyByListPaginated({
    idsLongread,
    limit: 0,
    offset: 0,
    page: 0,
    disabled: !longreadId,
  });

  const hasLongreadData = useMemo(() => {
    return longreadPaging && longreadPaging.count > 0;
  }, [longreadPaging]);

  const { theme, isDarkText } = createThemeByColor(bgColor, theme1, { isCompetition: true });
  const isDarkTheme = useMemo(() => !isDarkText, [isDarkText])

  const [{ allowedInfo, allowedStatus, isMaxAttemptsLimitLoading }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);
  const { nominations, isLoading: nominationsLoading } = useGetCompetitionNominations(competition?.competitionId ?? '', false )
  
  const hasEndedNominationsWithWinners = useMemo(() => {
    if (nominationsLoading) return false;
    return nominations?.some((n: any) =>
      [STATUSES.Completed, STATUSES.Archived]?.includes(n?.status) &&
      n?.nominations?.[0]?.winnerPositions?.length > 0
    ) ?? false;
  }, [nominations, nominationsLoading]);

  // @ts-ignore
  const showPreShortList = competition?.nominations?.[0]?.showPreShortList;

  useEffect(() => {
    dispatch(HseContextActions.set({
      tabs: TABS,
      initialTab,
    }));
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [TABS, dispatch])


  useEffect(() => {
    if (!profile && queryTab !== initialTab) {
      setQueryParams({ tab: TABS.about }, { replace: true });
    }
  }, [profile])

  const [activeTabKey, setActiveTabKey] = useState(queryTab);

  const isModer = useMemo(() => {
    if (profile && competition) {
      const hasPolicyCompetitionModer = profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

      return (bProfile.isModer(profile) || hasPolicyCompetitionModer ||
        competition?.moderatorID?.includes(profile?.accountId) ||
        competition?.administratorID?.includes(profile?.accountId)
      )
    }
  }, [profile, competition])

  const isBriefModer = useMemo(() => ((profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList)) || undefined), [profile])
  const isModerOrBriefModer = !!isModer || !!(isBriefModer && competition?.isBriefCompetition)

  const isCanSubmitOnBrief = useMemo(
    () => competition && !!competition?.isBriefCompetition &&
      allowedInfo && allowedInfo?.includes(CompetitionDisableBtnStatus.max_briefs), [competition, allowedInfo])

  //@ts-ignore
  const isAllowParticipants = useMemo(() => (competition?.allowEmptyParticipantRequests), [competition])

  const isParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.participantAccountIds?.includes(profile?.accountId)), [competition, profile])

  const isPendingParticipant = useMemo(
    //@ts-ignore
    () => (competition && competition?.pendingParticipantsIds?.includes(profile?.accountId)), [competition, profile])

  const isPreRegistrationCompetition = useMemo(() => {
    const rawType = competition?.competitionType;
    const hasCompetitionType = Number.isInteger(rawType);
    if (hasCompetitionType) {
      return rawType === COMPETITION_TYPE.PreRegistration;
    }
    return !!competition?.isPreRegistration;
  }, [competition]);

  const isCanViewPreRegistration = useMemo(
    //@ts-ignore
    () => (isPreRegistrationCompetition && !competition?.participantAccountIds?.includes(profile?.accountId) && competition?.status === STATUSES.Open),
    [profile, competition, isPreRegistrationCompetition]
  )

  const isCanSubmitProjects = useMemo(
    () => (
      /*isParticipant || */
      isPendingParticipant ||
      (isCanSubmitOnBrief && !isModer) ||
      (!!allowedInfo?.length && !isModer
      ) ||
      competition?.status !== STATUSES.Open
    )
    , [
      isParticipant,
      competition,
      isCanSubmitOnBrief,
      isModer,
      isPendingParticipant,
      allowedInfo
    ]);

  const isJury = useMemo(() => !!profile && !!competition?.juryID?.includes(profile?.designerId), [competition, profile]);
  const isVsContext = useMemo(() => (competition && competition?.contexts?.includes('hsevisualresearch')), [competition]);
  const isCompetitionModer = useMemo(() => profile && competition?.moderatorID?.includes(profile?.designerId), [competition, profile]);

    const tabVisibilityRules = useMemo(() => {
      const isAdmin = isModer || isCompetitionModer || isJury;
      const isPracticeCompetition = competition?.competitionType === COMPETITION_TYPE.Practices;
      const isOpenCompetition = COMPETITIONS_WITH_OPEN_PROJECTS.includes(competition?.competitionId || '')
      
      const getEnabledStatus = (tabId: string) => {
        return competition?.infoTabs?.find((tab) => tab.tabId === tabId)?.enable;
      }

      return {
        about: true,
        jury: isAdmin || getEnabledStatus(TAB_IDS.jury),
        projects: isAdmin || isPracticeCompetition || isOpenCompetition || getEnabledStatus(TAB_IDS.projects),
        shortlist: isAdmin || (getEnabledStatus(TAB_IDS.shortlist) && isCompetitionCompleted),
        results: !!(competition?.hasManyCompetitions && hasEndedNominationsWithWinners),
      }
    }, [isModer, isCompetitionModer, isJury, competition, hasEndedNominationsWithWinners])


    const formMethods = useForm({
      defaultValues: {}
    });
    // const { handleSubmit, reset, watch, setValue, control } = formMethods;

  const canViewStatements = useMemo(() => {
    if (!profile || !profile.rolesList || !Array.isArray(profile.rolesList)) {
      return false;
    }
    
    const hasLmsAdmin = (new ProfileRole(HsePolicies.lms_admin)).containsIn(profile.rolesList);
    const hasLmsChief = (new ProfileRole(HsePolicies.lms_scores_report_chief)).containsIn(profile.rolesList);
    const hasLmsEditor = (new ProfileRole(HsePolicies.lms_scores_report_editor)).containsIn(profile.rolesList);
    
    return isJury || hasLmsAdmin || hasLmsChief || hasLmsEditor;
  }, [profile, isJury]);

  // const isDarkTheme = useMemo(() => (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE' && competition?.isNewType), [competition])
  const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])
  const is1440 = useMemo(() => (isMac13 || smHeight), [isMac13, smHeight]);

  const canViewCompetitionPoint = useMemo(() => (
    (isJury && isVsContext) || isModer || isCompetitionModer), [isJury, isCompetitionModer, isVsContext, isModer]);

  const onMobileSortingChange = useCallback(() => {
    setSorting(Number(sorting) === 1 ? 2 : 1);
    setTime(Date.now())
  }, [sorting])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    setTime(Date.now());
  }, [setSorting])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        // hideRightBar={true}
        onSortingChange={onSortingChange}
        onToggleUnrated={() => { }}
        sortingMethods={canViewCompetitionPoint ? [1, 2, 13, ...(isJury ? [] : [])] : [1, 2]}
        isDarkTheme={isDarkTheme}
      />
    ),
    [onSortingChange, sorting, isMobile, sorting, canViewCompetitionPoint, isDarkTheme],
  );

  const MobileSearchBar = useMemo(
    () => (
      <MobileFilterRow
        // fixed={isMobile}
        importantWidth
        style={{
          marginTop: 0,
          justifyContent: 'flex-end',
          paddingTop: '0px',
          width: '100% !important'
        }}
      >
        <MobileFilterSort onClick={() => onMobileSortingChange()}>
          <SortIcon />
          {t(`sorting_type.${Number(sorting) === 1 ? 'latest' : Number(sorting) === 2 ? 'popular' : 'score'}`)}
        </MobileFilterSort>
      </MobileFilterRow>
    ), [isMobile, sorting])


  const UnratedBar = useMemo(() => {
    if (!(isJury && (activeTabKey === TABS.projects))) {
      return null;
    }
    return (
      <FlexBox style={{ justifyContent: 'flex-end', width: isMobile ? '100%' : 'initial' }} offsetTopMobile={0} offsetTop={is743BP ? 24 : 0} offsetRight={isMobile ? 0 : 16} offsetRightMobile={0}>
        <MagicBoxRow
          label={t('filter.unrated')}
          // checked={extraFilter?.globalType?.includes('employee') || extraFilter?.globalType?.length === 0}
          checked={Boolean(unrated)}
          style={{ margin: isMobile ? '0' : '0 0 0 0', color: isHSEDesign ? theme.text.label : theme.inputs.disabledColor }}
          onClick={() => {

            setQueryParams({
              unrated: unrated === 'true' ? '' : 'true',
              page: 1
            })
          }}
        />
      </FlexBox>
    )
  }, [unrated, setQueryParams, isMobile, activeTabKey, isJury])

  const competitionTabs = useMemo(() => {
    const tabs: Record<string, string> = {};
    const specialTabs: Record<string, string> = {};

    const getCustomTabName = (key: string, val: string): string => {
      const tabId = TAB_IDS[key as keyof typeof TAB_IDS];
      const infoTab = tabId && competition?.infoTabs?.find((t) => t.tabId === tabId);
      const stored = infoTab ? Lang(infoTab.name, i18n.language) : '';
      return stored || t(`competition.tabs.${val}`);
    };

    if (showPreShortList) {
      Object.entries(SPECIALTABS).forEach(([key, val]) => {
        specialTabs[key] = getCustomTabName(key, val);
      })
      return specialTabs
    }

    Object.entries(TABS).filter(([key, val]) => {
      return tabVisibilityRules[key as keyof typeof tabVisibilityRules]
    }).map(([key, val]) => {
      tabs[key] = getCustomTabName(key, val);
    })

    return tabs;
  }, [
    tabVisibilityRules,
    t,
    competition,
    i18n.language,
    showPreShortList,
  ]);

  //@ts-ignore
  const isPaidCompetition = useMemo(() => competition?.lmsModuleProjectId && competition?.isPaidApplication, [competition])
  //@ts-ignore
  const isExam = useMemo(() => !!competition?.lmsModuleProjectId, [competition])
  const isJoinCompetitionButtonTypeVisible = useMemo(() => {
    if (isExam) {
      return false;
    }

    //@ts-ignore
    const competitionType = competition?.competitionType;

    if (competitionType === COMPETITION_TYPE.WithNominations
      || competitionType === COMPETITION_TYPE.Automatic
      || isRatingCompetitionType(competitionType)) {
      return false;
    }

    if (competitionType === COMPETITION_TYPE.WithQuestionnaire
      || competitionType === COMPETITION_TYPE.WithoutQuestionnaire
      || competitionType === COMPETITION_TYPE.PreRegistration
      || competitionType === COMPETITION_TYPE.Practices
      || !!competition?.isPaidCompetition
      || competitionType === COMPETITION_TYPE.Special) {
      return true;
    }

    return isPreRegistrationCompetition;
  }, [competition, isExam, isPreRegistrationCompetition]);

  const actionButtonVisible = useMemo(() => {
    if (isPaidCompetition) {
      return false
    }
    if (!!isModer || !!(isBriefModer && competition?.isBriefCompetition)) {
      return competitionStatus < COMPETITION_STATUSES.full_finish
    }
    if (isExam) {
      return false
    }

    if (!isJoinCompetitionButtonTypeVisible) {
      return false;
    }
    if(competition?.status === STATUSES.Announcement) {
      return false;
    }
    return (competitionStatus === COMPETITION_STATUSES.default
      || competitionStatus === COMPETITION_STATUSES.deadline_soon)
  }, [competitionStatus, isPaidCompetition, isExam, isModer, isBriefModer, competition, isJoinCompetitionButtonTypeVisible])

  const statementsButtonVisible = useMemo(() => {
    return !!canViewStatements && !!competition?.lmsModuleProjectId;
  }, [canViewStatements, competition?.lmsModuleProjectId])
  const canRenderActionButtons = actionButtonVisible && (isModerOrBriefModer || !statementsButtonVisible)

  useEffect(() => {
    setActiveTabKey(queryTab);
  }, [queryTab]);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      CompetitionAPI.Get({ idCompetition: id, initWinner: true })
        .then((v) => v.json())
        .then((v) => {
          if (v.status && v.status === 403) {
              setAccessError(true);
              return;
          }
          //@ts-ignore
          if (v?.['ErrorStatusCode'] === 500 && v?.['ErrorMessage'] === BRIEF_ERROR_FORBIDDEN_MSG) {
            //@ts-ignore
            setBriefForbiddenError(true)
            return;
          }
          return API.toLang<Competition<'Local'>>(v, i18n.language)
        })
        .then((competition) => {
          // setCompetition(competition)

          dispatch(CurrentCompetitionActions.setCurrentCompetition(competition))
        })
        .finally(() => {
          if (isGreenAward) {
            setTimeout(() => setIsLoading(false), 1000)
          } else {
            setIsLoading(false)
          }
        })

    }
  }, [id, i18n.language]);

  useEffect(() => {
    const updateActiveOnScroll = (value: string) => {
      setTarget("");
      setScroll(true);
      setSelectedTab(value);
    };

    const handler = () => {
      const { scrollHeight, clientHeight } = document.documentElement;
      const { scrollY } = window;

      if (scrollY + 1 >= scrollHeight - clientHeight) {
        updateActiveOnScroll('contacts');
      } else if (scrollY <= 800) {
        setTarget("");
        setScroll(false);
        setSelectedTab('about');
      } else if (scrollY > 800 && scrollY <= 1200 && !is744BP) {
        updateActiveOnScroll('about');
      } else if (scrollY > 1200 && scrollY <= 1500 && !is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 800 && scrollY <= 1200 && is744BP) {
        updateActiveOnScroll('timing');
      } else if (scrollY > 1900 && scrollY <= 2600 && !is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 1200 && scrollY <= 2400 && is744BP) {
        updateActiveOnScroll('terms');
      } else if (scrollY > 2600 && scrollY <= 4200) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 2400 && scrollY <= 6800 && is744BP) {
        updateActiveOnScroll('marks');
      } else if (scrollY > 4200 && scrollY <= 5900 && !is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 6800 && scrollY <= 7300 && is744BP) {
        updateActiveOnScroll('prize');
      } else if (scrollY > 5900 && scrollY <= 6200 && !is744BP) {
        updateActiveOnScroll('contacts');
      } else if (scrollY > 7300 && is744BP) {
        updateActiveOnScroll('contacts');
      }
    };

    window.addEventListener('scroll', handler);
    scrollFunc(target, is744BP);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [target, selectedTab, scroll, is744BP]);

  useEffect(() => {
    return () => {
      dispatch(CurrentCompetitionActions.setCurrentCompetition(undefined))
    }
  } , [])

  const titleImages = useMemo(() => {
    if (competition?.isBilingual) {
      return i18n.language === 'en' ? competition?.titleImages_en : competition?.titleImages
    }
    return competition?.titleImages;
  }, [competition, i18n.language])

  //хардкод для для конкурса
  const showArrowTabIcon = useMemo(() => {
    return competition && competition?.competitionId === '43bd8964119e473c9944c1ef43aee6f2'
  }, [competition])

  const isBriefPreregistration = useMemo(
    () => (!!competition?.isBriefCompetition && isPreRegistrationCompetition && isCanViewPreRegistration),
    [competition, isCanViewPreRegistration, isPreRegistrationCompetition]
  )

  const buttonText = useMemo(
    () => {
      if (!!competition?.isBriefCompetition && isPreRegistrationCompetition) {
        return t(`hse_showcases_title.competitions.msg.${isCanViewPreRegistration ? 'go_requests' : 'send_project'}`)
      }

      return competition?.enrollButtonText ?? ''
    }, [t, competition, isCanViewPreRegistration, isPreRegistrationCompetition])



  const handleCopy = () => {
    const linkText = window.location.href;
    navigator.clipboard.writeText(linkText)
      .then(() => {
        info(t('notifications.copy_msg-success'))
      })
      .catch(err => {
        info(t('notifications.copy_msg-error'))
      });
  }

  const handlePaidCompetitionClick = useCallback(() => {
    if (!profile) {
      auth.login();
    } else {
      API.request()
        .endpoint(Endpoints.geoGateway)
        .url('/api/LMS/RequestToJoinCourse')
        .addQuery('projectId', competition?.lmsModuleProjectId ?? '')
        .post()
        .send()
        .then(() => {
          modal.show("access", {
            type: AccessModalTypes.LMS,
            projectId: competition?.lmsModuleProjectId
          });
        })

    }
  }, [profile, auth, modal]);

  // Обработчики событий
  const onTabChange = (tab: string) => {
    if (isDamuseum && !isCompetitionRoute) {
      history.push(CreateLinkTo.competition(competition?.competitionId ?? ''))
    }
    setQueryParams({ tab });
  }

  const backgroundColor = isGreenAward
    ? 'linear-gradient(to bottom, rgba(49, 83, 43, 1), rgba(118, 158, 57, 1))'
    : (
      isAcademy
        ? '#2A3034'
        : (
          (competition?.competitionColorTheme?.backgroundColor === '#FEFEFE'
            && competition?.competitionType === COMPETITION_TYPE.Automatic)
            ? theme.competition.bg
            : competition?.competitionColorTheme?.backgroundColor
        )
        || undefined
    )

  if (accessError) {
    return (
      <CompetitionErrorNotAllowed id={ id ?? '' }/>
    )
  }

  if (briefForbiddenError) {
    return (
      <CompetitionEditFrameForbidden id={''} />
    )
  }

  return (
    <>
      <MetaTags
        title={competition?.title ?? ''}
        images={competition?.titleImages}
      />
      <ThemeProvider theme={theme as any}>
            <FormProvider {...formMethods}>
        <CustomBgWrapper isCompetition backgroundColor={
          backgroundColor
        }
        >
          <MainBlock isMobile={is744BP} isAcademy={isAcademy}>
            <ProjectMetaBack />
            {competition?.isNewType ? (
              <HeaderBlock isMobile={is744BP}>
                <CompetitionView competition={competition} />
                <HeaderRightBlock isMobile={is744BP}>
                  <FlexBox width="100%" direction='column' directionMobile="column">
                    {/* {competition?.title && <TitleText isMobile={is743BP}>{competition?.title}</TitleText>} */}
                    {!is743BP && (<BTagsGridNew customShadowColor={backgroundColor} shadow>
                      {
                        competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                          <StatusPseudoTag onClick={(e: any) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }} mr={16} mb={12}>
                            {
                              t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                'competition.statuses.Competition_ended'
                                :
                                'competition.statuses.Competition_apply_ended')
                            }
                          </StatusPseudoTag>
                          :
                          undefined
                      }
                      {showRatingTag && (
                        <StatusPseudoTag backgroundColor="#29894E" onClick={(e: any) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }} mr={16} mb={12}>
                          {t('competition.statuses.rating_competition')}
                        </StatusPseudoTag>
                      )}
                      {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                        // @ts-ignore
                        const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                        const colorTheme = getCategoryColorTheme(v);
                        return (
                          // <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>

                          <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag colorTheme={colorTheme}>
                            {bTag.title(v)}
                            <ReactTooltip {...getTooltipStyles(theme as any)} />

                          </BTag>
                          // </LimitedLink>
                        )
                      })}
                    </BTagsGridNew>)}
                  </FlexBox>
                  <FlexBox width="100%" direction='column' justify={'end'} directionMobile={'column'}>

                    {is743BP && (<FlexBox>
                      <BottomOuterMobile>
                        {(competitionStatus === COMPETITION_STATUSES.full_finish
                          || competitionStatus === COMPETITION_STATUSES.apply_finish
                          || showRatingTag) && (
                          <MobileStatusPseudoTagsWrap>
                            {
                              competitionStatus === COMPETITION_STATUSES.full_finish || competitionStatus === COMPETITION_STATUSES.apply_finish ?
                                <StatusPseudoTag
                                  onClick={(e: any) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                  }}
                                  mr={8}>
                                  {
                                    t(competitionStatus === COMPETITION_STATUSES.full_finish ?
                                      'competition.statuses.Competition_ended'
                                      :
                                      'competition.statuses.Competition_apply_ended')
                                  }
                                </StatusPseudoTag>
                                :
                                null
                            }
                            {showRatingTag && (
                              <StatusPseudoTag
                                backgroundColor="#29894E"
                                onClick={(e: any) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                }}
                                mr={8}>
                                {t('competition.statuses.rating_competition')}
                              </StatusPseudoTag>
                            )}
                          </MobileStatusPseudoTagsWrap>
                        )}
                        <FlexBox directionMobile='row'>
                          <FlexBox offsetRight={'12px'}>
                            <IconCompetitionSpecial onClick={handleCopy}>
                              <ShareIcon />
                            </IconCompetitionSpecial>
                          </FlexBox>
                        </FlexBox>
                        {!![...competition?.requredTags, ...competition?.regularTags]?.length && (
                          <div className="BottomOuterMobileActions">
                            <FlexBox directionMobile="row" gxMobile={12}>
                              <TagsMobBtn isCompetition customText={t('tags_mobile_btn_text').toLowerCase()} onClick={setShowMobileTags} flag={showMobileTags} />
                            </FlexBox>
                          </div>
                        )}
                      </BottomOuterMobile>

                    </FlexBox>)}
                    {is743BP && showMobileTags && (<FlexBox offsetTopMobile={'10px'}>
                      <TagsMobile show={showMobileTags}>
                        {competition && [...competition.requredTags, ...competition.regularTags].map((v) => {
                          // @ts-ignore
                          const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                          const colorTheme = getCategoryColorTheme(v);
                          return (
                            <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target}>
                              {/*@ts-ignore*/}
                              <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag colorTheme={colorTheme}>
                                {bTag.title(v)}
                              </BTag>
                            </LimitedLink>
                          )
                        })}
                      </TagsMobile>
                    </FlexBox>)}
                    {!isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && !competition?.hasManyCompetitions && <DeadLineWarningWrapper>
                      <div><WarningIcon /></div>
                      <span>{t('competition.ten_days-remain_msg')}</span>
                    </DeadLineWarningWrapper>}
                    <FlexBox direction='row' directionMobile={'column'} width={'100%'} widthMobile={'100%'} justify='space-between' justifyMobile='space-between' align='flex-end' alignMobile='flex-start'>

                      {!is744BP && (
                        <FlexBox offsetBottom={0} offsetBottomMobile={16} direction='column' directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center' style={{ placeItems: 'center' }}>
                          <IconCompetitionSpecial onClick={handleCopy} style={{ marginBottom: 0, marginTop: (!isMobile && (competitionStatus === COMPETITION_STATUSES.default || competitionStatus === COMPETITION_STATUSES.deadline_soon)) ? 24 : 0 }}>
                            <ShareIcon />
                          </IconCompetitionSpecial>
                          {isMobile && competitionStatus === COMPETITION_STATUSES.deadline_soon && competition?.hasManyCompetitions && (
                            <DeadLineWarningWrapper>
                              <div><WarningIcon /></div>
                              <span>{t('competition.ten_days-remain_msg')}</span>
                            </DeadLineWarningWrapper>
                          )}
                        </FlexBox>
                      )}
                      {is743BP && competitionStatus === COMPETITION_STATUSES.deadline_soon && <DeadLineWarningWrapper>
                        <div><WarningIcon /></div>
                        <span>{t('competition.ten_days-remain_msg')}</span>
                      </DeadLineWarningWrapper>}
                      {(actionButtonVisible || statementsButtonVisible) && <FlexBox justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0} direction='column' align='flex-end' alignMobile='flex-start'>
                        {statementsButtonVisible && (
                          <FlexBox offsetBottom={8}  width={is744BP ? '100%' : 'auto'}>
                            <SendProjectButton
                              color={theme.competition.buttonText}
                              className='moder-button statements-button'
                              c={theme.competition.buttonBg}
                              hoverC={theme.competition.secondaryText}
                              onClick={() => {
                                history.push(`/estimate/${competition.lmsModuleProjectId}`);
                              }}
                              r="3"
                              fullWidth={false}
                            >
                              {t('lms.statements.title')}
                            </SendProjectButton>
                          </FlexBox>
                        )}
                        {canRenderActionButtons && <ActionsButtons
                          isModer={isModerOrBriefModer}
                          isPreRegistration={isCanViewPreRegistration}
                          isBriefPreregistration={isBriefPreregistration}
                          disabled={isCanSubmitProjects && !isGreenAward}
                          isAllowParticipants={isAllowParticipants ?? false}
                          needAuth={!profile}
                          text={buttonText}
                          allowedInfo={allowedInfo}
                          allowedStatus={allowedStatus}
                          isMaxAttemptsLimitLoading={isMaxAttemptsLimitLoading}
                        />}
                      </FlexBox>}
                      {isPaidCompetition && (
                        <HintTooltip
                          text={t('hints.paid_competition_hint')}
                          positionY='top'
                          onWhiteBg
                        >
                          <SendProjectButton
                            color={theme.competition.buttonText}
                            className='moder-button'
                            c={theme.competition.buttonBg}
                            hoverC={theme.competition.secondaryText}
                            onClick={handlePaidCompetitionClick}
                            r="3"
                          >
                            {t('competition.request_member')}
                          </SendProjectButton>
                        </HintTooltip>
                      )}

                    </FlexBox>
                  </FlexBox>
                </HeaderRightBlock>
              </HeaderBlock>
            ) : (
              <HeaderBlockNotAuto isMobile={is744BP}>
                <FlexBox direction="column" directionMobile='column-reverse'>
                  <SmthTitle isMobile={is744BP}>
                    <TitleTextNotAuto isMobile={is744BP}>{competition?.title}</TitleTextNotAuto>
                  </SmthTitle>
                  <SmthBanner isMobile={is744BP}>
                    <ResizedImageEnhanced files={titleImages} />
                  </SmthBanner>
                </FlexBox>
                <FlexBox width="100%" height={'auto'} justify='space-between' justifyMobile='flex-end' direction='row' directionMobile='column-reverse'
                  style={{ maxWidth: '1152px', placeItems: 'end' }}>
                  <SmthIconsWrapperNotAuto>
                    <CopyIcon onClick={handleCopy} />
                  </SmthIconsWrapperNotAuto>
                  {canRenderActionButtons && competition && <ActionsButtons
                    isModer={isModerOrBriefModer}
                    disabled={isCanSubmitProjects}
                    isPreRegistration={isCanViewPreRegistration}
                    isAllowParticipants={isAllowParticipants ?? false}
                    isBriefPreregistration={isBriefPreregistration}
                    fullWidth={breakpoint}
                    needAuth={!profile}
                    text={buttonText}
                    allowedInfo={allowedInfo}
                    allowedStatus={allowedStatus}
                    isMaxAttemptsLimitLoading={isMaxAttemptsLimitLoading}
                  />}
                </FlexBox>
              </HeaderBlockNotAuto>
            )}
            {is743BP && UnratedBar}
            <FlexBox width={'100%'} offsetTopMobile={16} offsetBottomMobile={'16px'} offsetBottom={!is1440 ? 4 : 0} justifyMobile='end'>
              {is743BP ? (
                <>
                  <FlexBox directionMobile='row' justifyMobile='space-between' widthMobile={'100%'} alignMobile='center'>
                    {!!Object.keys(competitionTabs)?.length && (
                      <Dropdown
                        offsetY={-2}
                        hideArrow
                        dark={isDarkTheme}
                        orientation={'left'}
                        target={
                          <ArrowTopIconWithText
                            fill={isDarkTheme ? theme.competition.secondaryText : undefined}
                            isCompetition={true}
                            text={competitionTabs[activeTabKey]}
                            shrimpIcon
                          />
                        }
                      >
                        {Object.keys(competitionTabs)?.map((key) => {
                          return (
                            <div key={key} onClick={() => {
                              if (key === activeTabKey) return false;
                              onTabChange(key);
                            }}>
                              <DropdownListItem
                                justify='space-between'
                                isActive={key === activeTabKey}
                              >
                                <DropdownText isDark={!!competition?.isNewType} isAcademy={isAcademy} isActive={key === activeTabKey}>
                                  {competitionTabs[key]}
                                </DropdownText>
                                <ApprovedIcon fill={theme.icon.active} display={key === activeTabKey} />
                              </DropdownListItem>
                            </div>
                          )
                        }
                        )}
                      </Dropdown>
                    )}
                    {activeTabKey === TABS.projects && MobileSearchBar}

                  </FlexBox>
                </>
              ) : (
                <FlexBox width={'100%'} offsetTop={!competition?.isNewType ? 20 : 0}>
                  <SlideNavigation
                    items={competitionTabs}
                    activeIndexKey={activeTabKey}
                    onChange={onTabChange}
                    //хардкод стрелки для конкруса
                    arrowIconId={showArrowTabIcon ? 'projects' : ''}
                    padding={24}
                    capitalize={true}
                  />
                  <TabletSortWrapper>
                    {UnratedBar}
                    {activeTabKey === TABS.projects && (isMobile ? MobileSearchBar : searchBar)}
                  </TabletSortWrapper>

                </FlexBox>
              )}
            </FlexBox>
            {(
              activeTabKey === TABS.about ? (
                <FlexBox offsetTopMobile={4} width={'100%'}>
                  <PSLongread project={competition as unknown as Project<"Local">} courseButtons={[]} />
                </FlexBox>
              ) : activeTabKey === TABS.jury ? (
                <CompetitionJuryPage openLikeTab externalId={externalId} />
              ) : activeTabKey === TABS.projects ? (
                <CompetitionProjectsPage openLikeTab mobileSorting={sorting} onMobileSortingChange={setSorting} isDarkTheme={isDarkTheme} externalId={externalId} />
              ) : [TABS.shortlist, TABS.results]?.includes(activeTabKey) ? (
                <ShortListPage showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : activeTabKey === 'select' ? (
                <PreShortListPage activeTabKey={activeTabKey} showPreShortList={showPreShortList} openLikeTab externalId={externalId} />
              ) : (
                <>
                  <PSLongread project={competition as unknown as Project<"Local">} courseButtons={[]} />
                </>
              )
            )}
            {activeTabKey === TABS.about && <NominationsView />}
            {!isLoading && canRenderActionButtons && hasLongreadData && !(['projects', 'shortlist'].includes(queryTab)) && <ButtonsWrapper isMobile={is744BP} justify='flex-end' justifyMobile='flex-start' widthMobile={'100%'} offsetTopMobile={is744BP ? (showMobileTags ? 14 : 24) : 0}>
              <ActionsButtons
                isModer={isModerOrBriefModer}
                isPreRegistration={isCanViewPreRegistration}
                isBriefPreregistration={isBriefPreregistration}
                disabled={isCanSubmitProjects}
                isAllowParticipants={isAllowParticipants ?? false}
                needAuth={!profile}
                text={buttonText}
                allowedInfo={allowedInfo}
                allowedStatus={allowedStatus}
                isMaxAttemptsLimitLoading={isMaxAttemptsLimitLoading}
              />
            </ButtonsWrapper>}
          </MainBlock>
        </CustomBgWrapper>
        </FormProvider>
      </ThemeProvider>
    </>
  );
};

export default GetCompetitionItem;
